export default function CustomError(error) {
  this.name = 'CustomError';
  this.message = (error.message || '');
  this.type = (error.type || '');
}

CustomError.prototype = Error.prototype;
